import React from 'react'
import styled from 'styled-components'
import { message } from 'antd'
import { containerIds } from 'modules/ui'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import { redirectTo } from 'frontend_core/dist/helpers/http'
import { imagePath } from 'frontend_core/dist/helpers/image'
import SMConst from 'frontend_core/dist/constants/sm-const'
import Path from 'routes/path'
import renderUIError from 'helper/renderUIError'

export default class PaidForm extends React.Component {
  changeFieldValue = (fieldName, value) => {
    const { ui, actions } = this.props
    const formValues = ui.paidForm || {}
    const uiErrors = ui.errors || []

    formValues[fieldName] = value
    uiErrors[fieldName] = null
    actions.setUIState(containerIds.BUSINESS_SIGNUP, {
      paidForm: formValues,
      errors: uiErrors,
    })
  }

  setContactUserFromAccount = e => {
    e.preventDefault()

    const { ui, actions, user } = this.props
    const formValues = ui.paidForm || {}

    formValues.contactPersonFamilyName = (user || {}).familyName
    formValues.contactPersonGivenName = (user || {}).givenName
    formValues.email = (user || {}).email

    const uiErrors = (ui.errors || []).filter(
      e =>
        e.fieldName !== 'contactPersonFamilyName' &&
        e.fieldName !== 'contactPersonGivenName' &&
        e.fieldName !== 'email',
    )

    actions.setUIState(containerIds.BUSINESS_SIGNUP, {
      paidForm: formValues,
      errors: uiErrors,
    })

    setTimeout(() => {
      document
        .getElementById('familyNameMdl')
        .parentNode.MaterialTextfield.checkDirty()
      document
        .getElementById('givenNameMdl')
        .parentNode.MaterialTextfield.checkDirty()
      document
        .getElementById('emailMdl')
        .parentNode.MaterialTextfield.checkDirty()
    }, 200)
  }

  confirmPaidForm = () => {
    this.props.validateCreateCompany()
  }

  render() {
    const { company, user, actions, ui, data, isShow } = this.props
    const currentUser = data.viewer

    const paidForm = ui.paidForm || {}
    const uiErrors = ui.errors || []

    return (
      <PaidFormWrapper className="signup-box" isShow={isShow}>
        <div className="row">
          <div className="col-xs-12">
            <h2 className="signup-box__title signup-box__title-other">
              担当者情報
            </h2>
            <p className="business-signup__description">
              個人アカウントの情報と同一でも登録できます。
              <br />
              担当者のメールアドレス宛に、審査結果や請求情報が送られます。
            </p>
            <div className="signup-box__wrapper-form">
              <div className="mb20">
                <a
                  href="#"
                  className="business-signup__link"
                  target="_blank"
                  onClick={this.setContactUserFromAccount}
                >
                  個人アカウントと同じ情報を使用する
                </a>
              </div>
              <div className="row signup-box__md-top">
                <InputField
                  wrapperClassName="col-sm-12 col-md-6"
                  label="姓"
                  id="familyNameMdl"
                  value={paidForm.contactPersonFamilyName || ''}
                  onChange={v =>
                    this.changeFieldValue('contactPersonFamilyName', v)
                  }
                  error={uiErrors}
                  fieldName="contactPersonFamilyName"
                />
                <InputField
                  wrapperClassName="col-sm-12 col-md-6"
                  label="名"
                  id="givenNameMdl"
                  value={paidForm.contactPersonGivenName || ''}
                  onChange={v =>
                    this.changeFieldValue('contactPersonGivenName', v)
                  }
                  error={uiErrors}
                  fieldName="contactPersonGivenName"
                />
                <InputField
                  wrapperClassName="col-sm-12 col-md-6 business-signup__align"
                  label="セイ（カナ）"
                  value={paidForm.contactPersonFamilyNameKana || ''}
                  onChange={v =>
                    this.changeFieldValue('contactPersonFamilyNameKana', v)
                  }
                  error={uiErrors}
                  fieldName="contactPersonFamilyNameKana"
                />
                <InputField
                  wrapperClassName="col-sm-12 col-md-6"
                  label="メイ（カナ）"
                  value={paidForm.contactPersonGivenNameKana || ''}
                  onChange={v =>
                    this.changeFieldValue('contactPersonGivenNameKana', v)
                  }
                  error={uiErrors}
                  fieldName="contactPersonGivenNameKana"
                />
                <InputField
                  wrapperClassName="col-sm-12 mb30"
                  label="メールアドレス"
                  id="emailMdl"
                  value={paidForm.email || ''}
                  onChange={v => this.changeFieldValue('email', v)}
                  example={
                    <p className="signup-box__example">
                      例：sample@spacemarket.com
                    </p>
                  }
                  error={uiErrors}
                  fieldName="email"
                />

                <div className="col-sm-12">
                  <h2 className="signup-box__title signup-box__title-other mt30">
                    会社情報
                  </h2>
                  <h3 className="business-subtitle">法人番号</h3>
                  <InputField
                    label="法人番号"
                    value={paidForm.businessTaxId || ''}
                    onChange={v => this.changeFieldValue('businessTaxId', v)}
                    example={
                      <p className="signup-box__example">
                        例：9011301020099
                        <a
                          href="https://www.houjin-bangou.nta.go.jp/"
                          className="ml10 business-link"
                          target="_blank"
                        >
                          法人番号を調べる
                        </a>
                      </p>
                    }
                    error={uiErrors}
                    fieldName="businessTaxId"
                  />
                  <h3 className="mt30 business-subtitle">会社名</h3>
                  <InputField
                    label="会社名"
                    value={paidForm.corpName || ''}
                    onChange={v => this.changeFieldValue('corpName', v)}
                    example={
                      <p className="signup-box__example">
                        例：株式会社スペースマーケット
                      </p>
                    }
                    error={uiErrors}
                    fieldName="name"
                  />
                  <InputField
                    label="会社名（カナ）"
                    value={paidForm.corpNameKana || ''}
                    onChange={v => this.changeFieldValue('corpNameKana', v)}
                    example={
                      <p className="signup-box__example">
                        例：カブシキガイシャスペースマーケット
                      </p>
                    }
                    error={uiErrors}
                    fieldName="corpNameKana"
                  />
                </div>
                <h3 className="col-sm-12 mt30 business-subtitle">代表者氏名</h3>
                <InputField
                  wrapperClassName="col-sm-12 col-md-6"
                  onChange={v => this.changeFieldValue('ceoFamilyName', v)}
                  label="姓"
                  value={paidForm.ceoFamilyName || ''}
                  error={uiErrors}
                  fieldName="ceoFamilyName"
                />
                <InputField
                  wrapperClassName="col-sm-12 col-md-6"
                  onChange={v => this.changeFieldValue('ceoGivenName', v)}
                  label="名"
                  value={paidForm.ceoGivenName || ''}
                  error={uiErrors}
                  fieldName="ceoGivenName"
                />
                <InputField
                  wrapperClassName="col-sm-12 col-md-6 business-signup__align"
                  onChange={v => this.changeFieldValue('ceoFamilyNameKana', v)}
                  label="セイ（カナ）"
                  value={paidForm.ceoFamilyNameKana || ''}
                  error={uiErrors}
                  fieldName="ceoFamilyNameKana"
                />
                <InputField
                  wrapperClassName="col-sm-12 col-md-6"
                  onChange={v => this.changeFieldValue('ceoGivenNameKana', v)}
                  label="メイ（カナ）"
                  value={paidForm.ceoGivenNameKana || ''}
                  error={uiErrors}
                  fieldName="ceoGivenNameKana"
                />
                <h3 className="col-sm-12 mt30 business-subtitle">会社所在地</h3>
                <InputField
                  wrapperClassName="col-xs-6 dib signup-box__col business-signup__align"
                  onChange={v => this.changeFieldValue('postalCode', v)}
                  label="郵便番号"
                  example={<p className="signup-box__example">例：1600023</p>}
                  value={paidForm.postalCode || ''}
                  error={uiErrors}
                  fieldName="postalCode"
                />
                <SelectLargeArea
                  onChangeValue={v => this.changeFieldValue('state', v)}
                  value={paidForm.state || ''}
                  onChangeText={v =>
                    actions.setUIState(containerIds.BUSINESS_SIGNUP, {
                      stateText: v,
                    })
                  }
                  error={uiErrors}
                  fieldName="state"
                />
                <InputField
                  wrapperClassName="col-sm-12 clear"
                  onChange={v => this.changeFieldValue('city', v)}
                  label="市区町村"
                  value={paidForm.city || ''}
                  example={<p className="signup-box__example">例：新宿区</p>}
                  error={uiErrors}
                  fieldName="city"
                />
                <InputField
                  wrapperClassName="col-sm-12"
                  onChange={v => this.changeFieldValue('address1', v)}
                  label="町名・番地"
                  value={paidForm.address1 || ''}
                  example={
                    <p className="signup-box__example">例：西新宿6-15-1</p>
                  }
                  error={uiErrors}
                  fieldName="address1"
                />
                <InputField
                  wrapperClassName="col-sm-12"
                  onChange={v => this.changeFieldValue('address2', v)}
                  label="ビル名・部屋番号"
                  value={paidForm.address2 || ''}
                  example={
                    <p className="signup-box__example">
                      例：ラ・トゥール新宿608
                    </p>
                  }
                  error={uiErrors}
                  fieldName="address2"
                />
                <h3 className="col-sm-12 mt30 business-subtitle">電話番号</h3>
                <InputField
                  wrapperClassName="col-sm-12"
                  onChange={v => this.changeFieldValue('tel', v)}
                  label="電話番号"
                  value={paidForm.tel || ''}
                  subtext={
                    <p className="business-subtext">
                      審査のため連絡可能な電話番号を入力してください。
                    </p>
                  }
                  example={
                    <p className="signup-box__example mb30">例：0312345678</p>
                  }
                  error={uiErrors}
                  fieldName="tel"
                />
                <PaymentBox
                  value={paidForm.paymentMethod}
                  onClickCard={() =>
                    this.changeFieldValue(
                      'paymentMethod',
                      SMConst.PaymentMethod.Card,
                    )
                  }
                  onClickPaid={() =>
                    this.changeFieldValue(
                      'paymentMethod',
                      SMConst.PaymentMethod.Paid,
                    )
                  }
                  error={uiErrors}
                  fieldName="paymentMethod"
                />
                <Terms
                  checked={ui.isTermsAgreed}
                  onChange={checked => {
                    actions.setUIState(containerIds.BUSINESS_SIGNUP, {
                      isTermsAgreed: checked,
                    })
                  }}
                />
                <Button onClick={this.confirmPaidForm} />
              </div>
            </div>
          </div>
        </div>
      </PaidFormWrapper>
    )
  }
}

const PaidFormWrapper = styled.div`
  ${({ isShow }) =>
    isShow
      ? `
    display: block;
  `
      : `
    display: none;
  `};
`

const InputField = ({
  wrapperClassName,
  id,
  label,
  example,
  error,
  fieldName,
  value,
  onChange,
}) => (
  <div className={wrapperClassName}>
    <div
      className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100pa"
      data-mdl-auto-init="mdlTextfield"
    >
      <input
        className="mdl-textfield__input"
        type="text"
        id={id}
        value={value}
        onChange={e => onChange(e.target.value)}
      />
      <label className="mdl-textfield__label" labelfor={id}>
        {label}
      </label>
    </div>
    {example}
    {renderUIError.signupError(fieldName, error)}
  </div>
)

const SelectLargeArea = ({
  value,
  onChangeValue,
  onChangeText,
  fieldName,
  error,
}) => (
  <div className="col-xs-6 fr">
    <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100pa">
      <span className="signup-box__select business-signup__select">
        <select
          id="state"
          value={value}
          onChange={e => {
            onChangeValue(e.target.value)
            const s = document.getElementById('state')
            onChangeText(s.options[s.selectedIndex].text)
          }}
        >
          <option value="">都道府県</option>
          <option value="tokyo">東京都</option>
          <option value="kanagawa">神奈川県</option>
          <option value="chiba">千葉県</option>
          <option value="saitama">埼玉県</option>
          <option value="ibaraki">茨城県</option>
          <option value="tochigi">栃木県</option>
          <option value="gunma">群馬県</option>
          <option value="osaka">大阪府</option>
          <option value="hokkaido">北海道</option>
          <option value="aomori">青森県</option>
          <option value="iwate">岩手県</option>
          <option value="miyagi">宮城県</option>
          <option value="akita">秋田県</option>
          <option value="yamagata">山形県</option>
          <option value="fukushima">福島県</option>
          <option value="niigata">新潟県</option>
          <option value="toyama">富山県</option>
          <option value="ishikawa">石川県</option>
          <option value="fukui">福井県</option>
          <option value="yamanashi">山梨県</option>
          <option value="nagano">長野県</option>
          <option value="gifu">岐阜県</option>
          <option value="shizuoka">静岡県</option>
          <option value="aichi">愛知県</option>
          <option value="mie">三重県</option>
          <option value="shiga">滋賀県</option>
          <option value="kyoto">京都府</option>
          <option value="hyogo">兵庫県</option>
          <option value="nara">奈良県</option>
          <option value="wakayama">和歌山県</option>
          <option value="tottori">鳥取県</option>
          <option value="shimane">島根県</option>
          <option value="okayama">岡山県</option>
          <option value="hiroshima">広島県</option>
          <option value="yamaguchi">山口県</option>
          <option value="tokushima">徳島県</option>
          <option value="kagawa">香川県</option>
          <option value="ehime">愛媛県</option>
          <option value="kouchi">高知県</option>
          <option value="fukuoka">福岡県</option>
          <option value="saga">佐賀県</option>
          <option value="nagasaki">長崎県</option>
          <option value="kumamoto">熊本県</option>
          <option value="oita">大分県</option>
          <option value="miyazaki">宮崎県</option>
          <option value="kagoshima">鹿児島県</option>
          <option value="okinawa">沖縄県</option>
        </select>
      </span>
    </div>
    <p className="signup-box__example">例：東京都</p>
    {renderUIError.signupError(fieldName, error)}
  </div>
)

const PaymentBox = ({ value, error, fieldName, onClickCard, onClickPaid }) => (
  <div className="business-payment-box">
    <h2 className="signup-box__title signup-box__title-other">
      お支払い方法について
    </h2>
    <p className="business-signup__description">
      クレジットカード、もしくは請求書による銀行振込（Paid）をご利用いただけます。登録後に法人アカウントの設定画面から変更ができますが、銀行振込（Paid）のご利用にはPaidへの登録と申請が必要です。
    </p>
    <div className="col-sm-12 mb20">
      <input
        type="radio"
        name="payment-method-radio"
        checked={value === SMConst.PaymentMethod.Card}
      />
      <label
        labelfor="request-radio__01"
        className="service-radio"
        onClick={onClickCard}
      >
        <span>クレジットカード</span>
      </label>
      <p className="business-text__card">
        クレジットカードをご利用の方は、お手数ですがログイン後設定画面からカード情報を入力してください。
      </p>
    </div>
    <div className="col-sm-12 mb10">
      <input
        type="radio"
        id="request-radio__02"
        name="payment-method-radio"
        checked={value === SMConst.PaymentMethod.Paid}
      />
      <label
        labelfor="request-radio__02"
        className="service-radio"
        onClick={onClickPaid}
      >
        <span>銀行振込（Paid）</span>
        <img src={imagePath('common/paid_logo.png')} />
      </label>
    </div>
    {renderUIError.signupError(fieldName, error)}
    <ul className="business-text__examination">
      <li>
        審査のため、Paidから登録電話番号へ確認のご連絡をさせていただきます。
      </li>
      <li>
        審査申請後、2〜3営業日でPaid（株式会社ラクーンフィナンシャル）より結果がメールで通知されます。
      </li>
      <li>
        Paid・審査について詳細は
        <a href="https://support.spacemarket.com/ja/articles/12e9d27b">
          ヘルプページ
        </a>
        をご覧ください。
      </li>
    </ul>
  </div>
)

const Terms = ({ checked, onChange }) => (
  <div className="col-sm-12 business-signup__terms">
    <label
      className="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect"
      labelfor="checkbox-1"
    >
      <input
        type="checkbox"
        className="mdl-checkbox__input"
        onChange={e => onChange(e.target.checked)}
      />
      <span className="mdl-checkbox__label">
        <a
          href={wwwUrl('/about/terms')}
          className="a__underline business-signup__link"
          target="_blank"
          rel="noopener noreferrer"
        >
          スペースマーケット利用規約
        </a>
        と
        <a
          href="/considaration"
          className="a__underline business-signup__link"
          target="_blank"
          rel="noopener noreferrer"
        >
          注意事項
        </a>
        に同意する
      </span>
    </label>
    <p className="signup-box__required">
      {checked ? (
        <span>&nbsp;</span>
      ) : (
        <span>
          <i className="fa fa-exclamation-circle" />
          スペースマーケット利用規約と注意事項に同意してください。
        </span>
      )}
    </p>
  </div>
)

const Button = ({ onClick }) => (
  <div className="col-sm-12 ta-c">
    <input
      type="button"
      name="commit"
      value="入力内容を確認する"
      onClick={onClick}
      className="button-green mt30 pt15 pb15 w300 sm-w100"
    />
  </div>
)
